<template>
    <div>
        <ScheduleSwitcher :open-view="scheduleSwitcherView" :timeslots="timeslots" :timeslot="timeslot" :speaker="speaker" :track="track" :sessions="sessions" :speakers="speakers" :breakout-tracks="breakoutTracks"></ScheduleSwitcher>
    </div>

</template>
<script>
    import ScheduleSwitcher from '../ScheduleSwitcher.vue'

    export default {
        components: {
            ScheduleSwitcher
        },

        props: [
            'args'
        ],

        data: function() {
            return {
                breakoutTracks: null,
                scheduleSwitcherView: null,
                sessions: null,
                speaker: null,
                speakers:null,
                timeslot: null,
                timeslots: null,
                track:null
            }
        },

        created: function() {
            console.log('args',this.args);
            this.scheduleSwitcherView   = this.args.scheduleSwitcherView;
            this.breakoutTracks         = this.args.breakoutTracks;
            this.sessions               = this.args.sessions;
            this.speaker                = this.args.speaker;
            this.speakers               = this.args.speakers;
            this.timeslot               = this.args.timeslot;
            this.timeslots              = this.args.timeslots;
            this.track                  = this.args.track;
        }
    }
</script>


// WEBPACK FOOTER //
// ScheduleModal.vue?55942f7e